<template lang="pug">
  v-container.postal-container.mt-2.pa-0(fluid)
    v-container#mini-postal.pa-0(fluid justify="center")
      v-container.postal.px-0.mt-3.pb-0(fluid)
        v-row.header
          v-col.py-0(d-flex xs=12 sm=5)
            v-card.justify-center.align-center(d-flex flat)
              img.info(src="../../static/logo.png")
          v-col.py-0.folio-container(d-flex xs=12 sm=7)
            v-card.fill.align-center(flat)
              h1.head.title {{ record.victimData.disappearanceMun ? record.victimData.disappearanceMun : 'Entidad' }}
              p.head.subtitle.main-text.pl-2.mr-3(fill-height align-center) Folio {{ record.folio ? `#${record.folio}` : '' }}

        v-row.pl-3.pr-3.pt-1.aggression(d-flex fill-height align="center")
          v-col.mt-3.mb-3(d-flex xs=12)
            v-card(flat d-flex).pr-2
              img.mt-3(width="100%" title="Cambiar imagen" fluid alt="profile img" v-if="(record.victimData.photo != '')" :src="record.victimData.photo")
              img.mt-3(width="100%" title="Cambiar imagen" fluid alt="profile img" v-else src="static/upload-icon.png")

          v-col.pl-3(xs7 align="center")
            v-row.mx-0.where(justify="center")
              v-col.border.pl-2.py-1(d-flex xs=11 sm=11 align="center")
                p.black-content-title-victim {{ record.victimData.name }}
              v-col.pl-2.py-1(d-flex xs=12 sm=12 align="center")
                p.info-title.pt-1 Nombre de la víctima
                  v-row.mx-0.where

            v-row.mx-0.where(justify="center")
              v-col.border.pl-2.py-1(d-flex xs=10 sm=10 align="center")
                p.content-title-victim {{ formatDate(record.victimData.disappearanceDate) }}
              v-col.pl-2.py-1(d-flex xs=12 sm=10 align="center")
                p.info-title.pt-1 Fecha de desaparición
                  v-row.mx-0.where

            v-row.mx-0.where(justify="center")
              v-col.border.py-1(d-flex xs=8 sm=8 align="center")
                p.content-title-victim {{ record.victimData.disappearanceAge }}
              v-col.py-1(d-flex xs=12 sm=12 align="center")
                p.info-title.pt-1 Edad al momento de desaparición
                  v-row.mx-0.where

</template>

<script>
export default {
  name: "Postal",
  computed: {
    record() {
      return this.$store.state.record;
    }
  },
  methods: {
    formatDate(value) {
      let month =
        value.month.length < 2 && value.month !== ""
          ? `0${value.month}`
          : value.month;
      let day =
        value.day.length < 2 && value.day !== "" ? `0${value.day}` : value.day;

      let date = day !== "" ? `${day}` : "";
      date += day !== "" && month !== "" ? "/" : "";
      date += month !== "" ? `${month}` : "";
      date += month !== "" && value.year !== "" ? "/" : "";
      date += value.year !== "" ? `${value.year}` : "";

      return date;
    }
  }
};
</script>

<style src="./postal.scss" lang="scss"></style>
